import GlassCard from '../../GlassCard';
import ProfileImage from './ProfileImage';
import HeroContent from './HeroContent';
import SocialLinks from './SocialLinks';
import ScrollButton from './ScrollButton';
import ResumeButton from './ResumeButton';
import { heroData } from '../../../assets/data/heroData';

export default function Hero() {
  return (
    <section id="hero" className="min-h-screen flex items-center justify-center px-4">
      <div className="max-w-4xl w-full">
        <GlassCard className="text-center border-emerald-400/30">
          <ProfileImage image={heroData.image} />
          <HeroContent data={heroData} />
          <div className="flex flex-row justify-center gap-6">
            <ScrollButton targetId="projects" />
            <ResumeButton label="Download Resume"/>
          </div>
          <SocialLinks links={heroData.socialLinks} />
        </GlassCard>
      </div>
    </section>
  );
}